import { render, staticRenderFns } from "./editlecturer.vue?vue&type=template&id=051dc275&scoped=true&"
import script from "./editlecturer.vue?vue&type=script&lang=js&"
export * from "./editlecturer.vue?vue&type=script&lang=js&"
import style0 from "./editlecturer.vue?vue&type=style&index=0&id=051dc275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051dc275",
  null
  
)

export default component.exports